import React from 'react';
import { ExternalLink, Phone, MessageSquare, FileText, AlertCircle } from 'lucide-react';
export function LinksAndResources() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-760">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-761">
        {/* Page Header */}
        <div className="text-center mb-12" data-id="element-762">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-763">
            LINKS & RESOURCES
          </h1>
        </div>

        {/* ADRE and other Useful Links Section */}
        <div className="mb-12" data-id="element-764">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-765">
            ADRE and other Useful Links
          </h2>

          {/* Student Log-In Link */}
          <div className="mb-6" data-id="element-766">
            <p className="text-base" data-id="element-767">
              <span className="text-green-600 font-bold italic" data-id="element-768">
                Go Back To Student Log-In
              </span>{' '}
              <a href="http://www.desertsageseminars.com/Home.html" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700 underline" data-id="element-769">
                http://www.desertsageseminars.com/Home.html
              </a>
            </p>
          </div>

          {/* ADRE Contact */}
          <div className="mb-6" data-id="element-770">
            <p className="text-base font-bold italic" data-id="element-771">
              Arizona Department of Real Estate (ADRE) 602-771-7799
            </p>
          </div>

          {/* Appointment Notice */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-8 rounded" data-id="element-772">
            <div className="flex items-start" data-id="element-773">
              <AlertCircle className="w-5 h-5 text-yellow-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-774" />
              <p className="text-base text-gray-900" data-id="element-775">
                <strong data-id="element-776">
                  As of August 30, 2024, ADRE has moved to appointment-only for
                  in-person assistance. If you would like in-person assistance,
                  please reach out using their{' '}
                  <a href="https://azre.gov/message-center" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline" data-id="element-777">
                    Message Center
                  </a>
                </strong>
              </p>
            </div>
          </div>
        </div>

        {/* QUESTIONS FOR ADRE Section */}
        <div className="bg-gray-50 px-8 py-10 mb-12 rounded-lg border border-gray-200" data-id="element-778">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-779">
            QUESTIONS FOR ADRE?
          </h2>

          <div className="space-y-6" data-id="element-780">
            {/* Message Center */}
            <div className="pb-6 border-b border-gray-200" data-id="element-781">
              <p className="text-base text-gray-900 mb-2" data-id="element-782">
                We recommend using the <strong data-id="element-783">Message Center</strong> to
                receive responses in writing for your records:
              </p>
              <a href="https://azre.gov/message-center" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 font-semibold text-lg inline-flex items-center" data-id="element-784">
                https://azre.gov/message-center
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-785" />
              </a>
            </div>

            {/* Find Your License Number */}
            <div className="pb-6 border-b border-gray-200" data-id="element-786">
              <p className="text-base font-bold italic mb-2" data-id="element-787">
                *Find Your License Number
              </p>
              <a href="http://services.azre.gov/publicdatabase/SearchIndividuals.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-788">
                http://services.azre.gov/publicdatabase/SearchIndividuals.aspx
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-789" />
              </a>
            </div>

            {/* Enter CE Classes */}
            <div className="pb-6 border-b border-gray-200" data-id="element-790">
              <p className="text-base font-bold italic mb-2" data-id="element-791">
                *Enter CE Classes
              </p>
              <p className="text-sm text-gray-600 mb-2" data-id="element-792">
                (have your license number ready to create or log in to account):
              </p>
              <a href="https://az.gov/webapp/dre/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-793">
                https://az.gov/webapp/dre/
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-794" />
              </a>
            </div>

            {/* ADRE Fee Schedule */}
            <div className="pb-6 border-b border-gray-200" data-id="element-795">
              <p className="text-base font-bold italic mb-2" data-id="element-796">
                *ADRE Fee Schedule:
              </p>
              <a href="https://azre.gov/sites/default/files/ADRE_Fee_Schedule.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-797">
                https://azre.gov/sites/default/files/ADRE_Fee_Schedule.pdf
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-798" />
              </a>
            </div>

            {/* Log in or update */}
            <div data-id="element-799">
              <p className="text-base font-bold italic mb-2" data-id="element-800">
                *Log in or update your personal information at ADRE or :
              </p>
              <a href="https://ptl.az.gov/app/dre/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-801">
                https://ptl.az.gov/app/dre/
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-802" />
              </a>
            </div>
          </div>
        </div>

        {/* Tech Helpline Section */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-803">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-6" data-id="element-804">
            Tech Helpline
          </h2>

          <div className="space-y-4" data-id="element-805">
            <p className="text-lg text-gray-900" data-id="element-806">
              Did you know that you can get tech help for ALL of your devices?
            </p>
            <p className="text-lg text-gray-900 ml-10" data-id="element-807">
              It's "free"... paid for with your{' '}
              <strong data-id="element-808">
                REALTOR<sup data-id="element-809">®</sup>
              </strong>{' '}
              dues!
            </p>

            <div className="mt-6 bg-gray-50 p-6 rounded-lg" data-id="element-810">
              <p className="text-base font-bold text-gray-900 mb-3" data-id="element-811">
                Contact Tech HelpLine:
              </p>
              <div className="space-y-2" data-id="element-812">
                <p className="text-base text-gray-900" data-id="element-813">
                  <strong data-id="element-814">Phone:</strong> (866) 232-1791
                </p>
                <p className="text-base text-gray-900" data-id="element-815">
                  <strong data-id="element-816">Online chat or support:</strong>{' '}
                  <a href="http://chat.techhelpline.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline" data-id="element-817">
                    http://chat.techhelpline.com
                  </a>
                </p>
              </div>
            </div>

            <div className="mt-6 bg-gray-50 p-6 rounded-lg" data-id="element-818">
              <p className="text-base font-bold text-gray-900 mb-3" data-id="element-819">Hours:</p>
              <div className="space-y-1" data-id="element-820">
                <p className="text-base text-gray-900" data-id="element-821">
                  Monday through Friday—9 am to 8 pm, Eastern Time
                </p>
                <p className="text-base text-gray-900" data-id="element-822">
                  Saturday—9 am to 5 pm, Eastern Time
                </p>
                <p className="text-base text-gray-900" data-id="element-823">Sunday—closed</p>
              </div>
            </div>
          </div>
        </div>

        {/* Residential Landlord/Tenant Act Section */}
        <div className="bg-gray-50 px-8 py-10 mb-12 rounded-lg border border-gray-200" data-id="element-824">
          <h2 className="text-2xl font-bold mb-4" data-id="element-825">
            <a href="https://housing.az.gov/sites/default/files/documents/files/Landlord_Tenant_Act_May-2023_1.pdf" target="_blank" rel="noopener noreferrer" className="text-[#fcb53d] hover:text-[#e5a436] inline-flex items-center" data-id="element-826">
              Residential Landlord/Tenant Act
              <ExternalLink className="w-5 h-5 ml-2" data-id="element-827" />
            </a>
          </h2>

          <p className="text-base text-gray-700" data-id="element-828">
            This is the text of the Arizona Statute that provides the rights and
            obligations of landlords and tenants in residential properties.
          </p>
        </div>

        {/* Other Useful Sites Section */}
        <div className="mb-12" data-id="element-829">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-830">
            Other Useful Sites-click for links:
          </h2>

          {/* Federal Government/National Sites */}
          <div className="mb-10 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-831">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-832">
              Federal Government/National Sites
            </h3>
            <ul className="space-y-3" data-id="element-833">
              <li className="text-base" data-id="element-834">
                <a href="https://www.consumerfinance.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-835">
                  Consumer Financial Protection Bureau (CFPB)
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-836" />
                </a>
              </li>
              <li className="text-base" data-id="element-837">
                <a href="https://www.hud.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-838">
                  US Department of Housing and Urban Development (HUD)
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-839" />
                </a>
              </li>
              <li className="text-base" data-id="element-840">
                <a href="https://www.donotcall.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-841">
                  National Do Not Call Registry
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-842" />
                </a>
              </li>
              <li className="text-base" data-id="element-843">
                <a href="https://www.va.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-844">
                  Department of Veterans Affairs
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-845" />
                </a>
              </li>
              <li className="text-base" data-id="element-846">
                <a href="https://www.hudhomestore.com/Home/Index.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-847">
                  HUD Home Store
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-848" />
                </a>{' '}
                <span className="text-gray-600" data-id="element-849">
                  (to sell HUD foreclosed properties, check with your broker)
                </span>
              </li>
            </ul>
          </div>

          {/* State of Arizona Sites */}
          <div className="mb-10 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-850">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-851">
              State of Arizona Sites
            </h3>
            <ul className="space-y-3" data-id="element-852">
              <li className="text-base" data-id="element-853">
                <a href="https://az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-854">
                  State of Arizona
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-855" />
                </a>
              </li>
              <li className="text-base" data-id="element-856">
                <a href="https://difi.az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-857">
                  Department of Financial Institutions
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-858" />
                </a>
              </li>
              <li className="text-base" data-id="element-859">
                <a href="http://www.azdeq.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-860">
                  Arizona Department of Environmental Quality
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-861" />
                </a>
              </li>
              <li className="text-base" data-id="element-862">
                <a href="https://azdohs.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-863">
                  Arizona Department of Homeland Security
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-864" />
                </a>
              </li>
              <li className="text-base" data-id="element-865">
                <a href="https://roc.az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-866">
                  Arizona Registrar of Contractors
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-867" />
                </a>
              </li>
              <li className="text-base" data-id="element-868">
                <a href="http://www.azcc.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-869">
                  Arizona Corporation Commission
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-870" />
                </a>
              </li>
              <li className="text-base" data-id="element-871">
                <a href="https://azsos.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-872">
                  Arizona Secretary of State
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-873" />
                </a>
              </li>
              <li className="text-base" data-id="element-874">
                <a href="https://www.azag.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-875">
                  Arizona Attorney General
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-876" />
                </a>
              </li>
            </ul>
          </div>

          {/* Arizona County Sites */}
          <div className="bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-877">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-878">
              Arizona County Sites (partial list)
            </h3>
            <ul className="space-y-3" data-id="element-879">
              <li className="text-base" data-id="element-880">
                <a href="http://www.coconino.az.gov/119/Assessor" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-881">
                  Coconino County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-882" />
                </a>
              </li>
              <li className="text-base" data-id="element-883">
                <a href="http://www.coconino.az.gov/319/Recorder" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-884">
                  Coconino County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-885" />
                </a>
              </li>
              <li className="text-base" data-id="element-886">
                <a href="https://mcassessor.maricopa.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-887">
                  Maricopa County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-888" />
                </a>
              </li>
              <li className="text-base" data-id="element-889">
                <a href="https://recorder.maricopa.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-890">
                  Maricopa County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-891" />
                </a>
              </li>
              <li className="text-base" data-id="element-892">
                <a href="http://www.asr.pima.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-893">
                  Pima County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-894" />
                </a>
              </li>
              <li className="text-base" data-id="element-895">
                <a href="https://www.recorder.pima.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-896">
                  Pima County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-897" />
                </a>
              </li>
              <li className="text-base" data-id="element-898">
                <a href="http://www.pinalcountyaz.gov/Assessor/Pages/home.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-899">
                  Pinal County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-900" />
                </a>
              </li>
              <li className="text-base" data-id="element-901">
                <a href="http://www.pinalcountyaz.gov/Recorder/Pages/home.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-902">
                  Pinal County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-903" />
                </a>
              </li>
              <li className="text-base" data-id="element-904">
                <a href="http://www.yumacountyaz.gov/government/assessor" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-905">
                  Yuma County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-906" />
                </a>
              </li>
              <li className="text-base" data-id="element-907">
                <a href="http://www.yumacountyaz.gov/government/recorder" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-908">
                  Yuma County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-909" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}